import { Hospitalisation, Patient } from "@/src/data/allTypes";
import { useState } from "react";
import { HospitalisationHistoryItem } from "./hospitalisationsHistory";
import { openPatientDashboard } from "./patientDashboard";
import { PatientsListItem } from "./patientsListItem";

export function UniversalItem({
  value,
  onClick,
}: {
  value: any;
  onClick?: () => void;
}) {
  const [item, setItem] = useState(value);
  if (!item) return null;

  if (item.firstName || item.lastName) {
    let patient = item as Patient;
    <PatientsListItem
      patient={patient}
      selectedPatient={null}
      searchKey={""}
      onSelect={async (patient) => {
        await openPatientDashboard(patient, (newValue) => {
          setItem(newValue);
        });
      }}
    ></PatientsListItem>;
  }

  if (item.type == "hospitalisation") {
    let hospitalisation = item as Hospitalisation;
    if (!hospitalisation.patient) return null;
    return (
      <HospitalisationHistoryItem
        item={hospitalisation}
        isDeletable={false}
        patient={hospitalisation.patient}
        onConfirm={(newValue) => {
          if (onClick) return onClick();
          setItem(newValue);
        }}
      />
    );
  }

  return null;
}
